import { InputField, InputFieldProps } from '@pvh-components/input-field';
import { ChangeEvent, forwardRef, useEffect, useState } from 'react';
import { filterNonNumerics } from './filterNonNumerics';

export type NumberFieldProps = Omit<InputFieldProps, 'inputType'>;

/**
 * Wrapper component to ensure that non-numeric characters cannot be entered
 * on Safari, while still showing the number keyboard.
 */
const NumberFieldWithoutRef = ({
  onChange,
  value = '',
  ...rest
}: NumberFieldProps) => {
  const [filteredValue, setFilteredValue] = useState(filterNonNumerics(value));
  useEffect(() => setFilteredValue(value), [value]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const filteredValue = filterNonNumerics(event.target.value);
    const filteredEvent = { ...event };
    filteredEvent.target.value = filteredValue;
    setFilteredValue(filteredValue);
    onChange?.(filteredEvent);
  };

  return (
    <InputField
      value={filteredValue}
      onChange={handleChange}
      inputType="tel"
      {...rest}
    />
  );
};

const NumberField = forwardRef((props: NumberFieldProps, ref) => (
  <NumberFieldWithoutRef inputRef={ref} {...props} />
));

export default NumberField;
